import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { addDays } from 'date-fns';

import { Paper, Grid, Collapse, IconButton } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import EmployeeChip from './EmployeeChip';
import {
  formatDateOnlyStringFromLocalTime,
  getMonthName,
} from '../../helpers/helpers';

import BOOKING_STATUS from '../../constants/employeeBookingStatus';

import i18n from '../../i18n';
import { logoProfileUrl } from '../../constants/general';

import '../../assets/stylesheets/ScheduleView.css';

class UnbookedFreelancerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: false,
    };
  }

  handleExpandClick = () => {
    this.setState((prevState) => ({ expandView: !prevState.expandView }));
  };

  generateDaysOfSelectedWeek = () => {
    const { startOfSelectedWeek, includeWeekend } = this.props;
    const numOfDays = includeWeekend ? 7 : 5;
    const selectedWeekDays = [];
    let currentDate = new Date(startOfSelectedWeek.getTime()); // new Date() is required because setDate() modifies reference value

    for (let i = 0; i < numOfDays; i++) {
      selectedWeekDays.push(formatDateOnlyStringFromLocalTime(currentDate));
      currentDate = addDays(currentDate, 1);
    }
    return selectedWeekDays;
  };

  displayHeadings = () => {
    const { startOfSelectedWeek, includeWeekend } = this.props;
    const numOfDays = includeWeekend ? 7 : 5;
    const formattedDates = [];
    let currentDate = new Date(startOfSelectedWeek.getTime()); // new Date() is required because setDate() modifies reference value

    for (let i = 0; i < numOfDays; i++) {
      const month = getMonthName(currentDate).substring(0, 3);
      const dateNumber = currentDate.getDate();
      formattedDates.push(`${month} ${dateNumber}`);
      currentDate = addDays(currentDate, 1);
    }

    return (
      <>
        <Grid item xs={2} />
        {formattedDates.map((date) => (
          <Grid
            item
            xs={includeWeekend ? 1 : 2}
            className={`dateLabel ${
              includeWeekend ? 'customGridItem includeWeekend' : ''
            }`}
            key={date}
          >
            {date}
          </Grid>
        ))}
        <Grid item xs={12}>
          <hr />
        </Grid>
      </>
    );
  };

  displaySchedule = () => {
    const { expandView } = this.state;
    const { scheduleData, onEmployeeSelect, includeWeekend } = this.props;
    const daysInSelectedWeek = this.generateDaysOfSelectedWeek();
    const unbookedFreelancersByDate = scheduleData
      ? _.groupBy(scheduleData, 'date', 'asc')
      : [];
    return scheduleData ? (
      <Collapse in={expandView} timeout="auto">
        <Grid container>
          {this.displayHeadings()}
          <React.Fragment key="unbooked freelancers thing">
            <Grid item xs={2} className="locationLabel">
              {i18n.t('schedule:availableFreelancers').toUpperCase()}
            </Grid>
            {daysInSelectedWeek.map((day) => {
              return (
                <Grid
                  key={`unbooked-freelance-${day}`}
                  item
                  xs={includeWeekend ? 1 : 2}
                  className={
                    includeWeekend ? 'customGridItem includeWeekend' : ''
                  }
                >
                  {unbookedFreelancersByDate[day]
                    ? Object.values(unbookedFreelancersByDate[day]).map(
                        (availbleFreelancer) => {
                          const {
                            id,
                            firstName,
                            lastName,
                            nickName,
                            profileImage,
                          } = availbleFreelancer.studioEmployee;
                          const employeeNmae = nickName || `${firstName} ${lastName}`;
                          return (
                            <EmployeeChip
                              key={`unbooked-${day}-${id}`}
                              availabilityType={availbleFreelancer.availabilityType}
                              positionId={0}
                              locationId={0}
                              bookedDate={day}
                              employeeId={id}
                              employeeName={employeeNmae}
                              profileImage={
                                profileImage || logoProfileUrl
                              }
                              isSelected={false}
                              status={BOOKING_STATUS.UNBOOKED_FREELANCER}
                              onEmployeeSelect={onEmployeeSelect}
                            />
                          );
                        }
                      )
                    : null}
                </Grid>
              );
            })}

            <Grid item xs={12}>
              <hr />
            </Grid>
          </React.Fragment>
        </Grid>
      </Collapse>
    ) : null;
  };

  render() {
    const { expandView } = this.state;

    return (
      <Paper id="Unbooked Freelancers" className="blockContainer">
        <div className="blockHeader">
          <h2>{i18n.t('schedule:unbookedFreelancers')}</h2>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMoreIcon color="secondary" />
          </IconButton>
        </div>
        {this.displaySchedule()}
      </Paper>
    );
  }
}

UnbookedFreelancerTable.propTypes = {
  startOfSelectedWeek: PropTypes.instanceOf(Date).isRequired,
  scheduleData: PropTypes.arrayOf(PropTypes.object).isRequired,
  onEmployeeSelect: PropTypes.func.isRequired,
  includeWeekend: PropTypes.bool.isRequired,
};

export default UnbookedFreelancerTable;
